import { useState, useEffect, useMemo } from 'react';
import eventsData from '../data/events.json';

export const useEvents = (filters = {}) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 100);
    return () => clearTimeout(timer);
  }, []);

  const events = useMemo(() => {
    let result = [...eventsData];

    // Apply search filter
    if (filters.search) {
      const search = filters.search.toLowerCase();
      result = result.filter(e =>
        e.titre.toLowerCase().includes(search) ||
        e.description?.toLowerCase().includes(search)
      );
    }

    // Apply type filter
    if (filters.type) {
      result = result.filter(e => e.type === filters.type);
    }

    // Apply status filter (default to published)
    if (filters.statut) {
      result = result.filter(e => e.statut === filters.statut);
    }

    return result;
  }, [filters.search, filters.type, filters.statut]);

  const getEvent = async (id) => {
    return eventsData.find(e => e.id === parseInt(id)) || null;
  };

  return {
    events,
    loading,
    pagination: { total: events.length },
    getEvent,
    loadEvents: () => { },
    createEvent: async () => { },
    updateEvent: async () => { },
    publishEvent: async () => { },
    deleteEvent: async () => { }
  };
};

export const useNews = () => {
  const [news] = useState([]);
  const [loading] = useState(false);

  return {
    news,
    loading,
    loadNews: () => { },
    getNewsItem: () => ({}),
    createNews: () => { },
    updateNews: () => { },
    publishNews: () => { },
    deleteNews: () => { }
  };
};
